import { z } from "zod";

import { FormIdSchema } from "./formId";

/** `?form=` on the evaluation routes (spec 017): the form to open first; an invalid value is ignored. */
export const EvaluationSearchSchema = z.object({
  form: z.unknown().optional().transform((value) => {
    const parsed = FormIdSchema.safeParse(Number(value));
    return parsed.success ? parsed.data : undefined;
  }),
});
